/**
* Browserify entry for bundling
* Modules are bundled in js gulp task
* !!! This file is NOT used when using RequireJS
*/
import 'core-js/es6/weak-map';
import 'core-js/fn/array/find';
import 'core-js/fn/array/from';
import 'core-js/fn/object/assign';

import CustomEvent from 'polyfill/CustomEvent'; // eslint-disable-line
import 'picturefill';

import 'utils/AutoSubmit';
import conditioner from 'conditioner-js';
import 'conditioner-js/dist/min/monitors/media';
import 'toggle/Trigger';
import 'toggle/Toggle';
import 'ui/Collapsible';
import 'ui/ToggleGroup';
import 'form/FormValidationBrochures';
import 'shared/external-link-helper/ExternalLinkHelper';

// Setup conditioner loader to load modules from bundle
conditioner.setOptions({
    loader: {
        require: (paths, callback) => {
            let module = require(paths);

            if (module.default) {
                module = module.default;
            }

            return callback(module);
        },

        toUrl: path => path
    },
    paths: {
        monitors: 'conditioner-js/dist/min/monitors/'
    }
});

// Initialize Conditioner
conditioner.init();
